import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { convertTradableToFiat } from "@helpers/tradable-convert";
import {
	BestRewardsViewModel,
	BestRewardsWeeklyFacade
} from "@modules/new_account/features/my-best/domain/+state/best-rewards-weekly.facade";

@Injectable()
export class BestWidgetWeeklyFacade {
	constructor(private readonly bestRewardsWeeklyFacade: BestRewardsWeeklyFacade) {}

	public getBestWidgetViewModel$(): Observable<BestWidgetModel> {
		return this.bestRewardsWeeklyFacade.getBestRewards$().pipe(
			map((bestRewards) => {
				const showVipOrTradeBonus = this.getVipOrTrade(bestRewards);
				return { ...bestRewards, showVipOrTradeBonus };
			})
		);
	}

	// true means VIP, false means Trade
	private getVipOrTrade(bestReward: BestRewardsViewModel): boolean {
		const { next_trade_stocks, next_trade_crypto, next_vip_levels_threshold_trade } = bestReward;

		// if all the "next" properties exist (means we are not max level VIP or trade)
		// then determine which one is closer to next level
		if (!!next_trade_stocks && !!next_trade_crypto && !!next_vip_levels_threshold_trade) {
			const { bestAsset, defaultFiat } = bestReward;
			const fiatAmountToNextVipLevel = convertTradableToFiat(
				bestAsset,
				+next_vip_levels_threshold_trade,
				defaultFiat
			);
			return +next_trade_crypto > fiatAmountToNextVipLevel; // we check just crypto because required amount is smaller
		}

		// else means that either one or both of them are max

		return !next_trade_crypto;
	}
}

export interface BestWidgetModel extends BestRewardsViewModel {
	showVipOrTradeBonus: boolean;
}
